import { type TypographyProps } from "@mui/material/Typography";
import { BodyTextS } from "@repo/ui";
import { type FC, type PropsWithChildren } from "react";

export type LabelProps = PropsWithChildren<TypographyProps>

export const Label: FC<LabelProps> = ({ children, sx, ...rest }) => (
	<BodyTextS
		component="p"
		mb={0}
		{...rest}
		sx={{
			...sx,
			py: 2,
		}}
	>
		{children}
	</BodyTextS>
);


export type ChartLabelProps = PropsWithChildren<{
	color: string;
}>

const ChartLabel: FC<ChartLabelProps> = ({
	children,
	color,
	...rest
}) => (
	<Label
		{...rest}
		sx={{
			position: "relative",
			pl: 5,
			"&:before": {
				position: "absolute",
				top: "6px",
				left: 0,
				display: "block",
				width: 16,
				height: 16,
				borderRadius: 1,
				background: color,
				content: "''",
			},
		}}
	>
		{children}
	</Label>
);

export default ChartLabel;
